module.exports = __webpack_public_path__ + "img/MW.d3c841da.svg";